// extracted by mini-css-extract-plugin
export default {"root":"NewEditKit_root__EttDy","placeHolderShimmer":"NewEditKit_placeHolderShimmer__+fbRI"};